import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_GODDIVA_API_BASE_URL;
const API_AUTH_URL = process.env.REACT_APP_GODDIVA_API_AUTH_URL;

const CLIENT_ID = process.env.REACT_APP_GODDIVA_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_GODDIVA_CLIENT_SECRET;

let accessTokenClient = null;
let tokenExpireTime = null;

async function getAccessToken() {

    if (accessTokenClient && tokenExpireTime > Date.now()) {
        return accessTokenClient;
    }

    const formData = new FormData();

    formData.append("grant_type", "client_credentials");
    formData.append("client_id", CLIENT_ID);
    formData.append("client_secret", CLIENT_SECRET);

    const response = await axios.post(API_AUTH_URL, formData, {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/json"
        }
    });

    accessTokenClient = response.data.access_token;

    tokenExpireTime = Date.now() + (response.data.expires_in * 1000);

    return accessTokenClient;
}

export async function apiRequest(config) {

    const token = await getAccessToken();

    return axios({
        baseURL: API_BASE_URL,
        ...config,
        headers: {
            ...config.headers,
            Authorization: `Bearer ${token}`,
            // "Accept": "application/json"
        }
    });
}